import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#FBF7F0] px-4 py-12 sm:px-6 lg:px-8 lg:py-20" data-id="element-91">
      <div className="absolute inset-0 bg-gradient-to-b from-[#FFF5F0]/50 to-transparent" data-id="element-92" />
      <div className="relative mx-auto max-w-7xl" data-id="element-93">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-8" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-95">
            <span className="mb-4 block font-sans text-sm font-bold uppercase tracking-widest text-[#D4603A]" data-id="element-96">
              The Postpartum Identity & Body Restoration Method
            </span>
            <h1 className="mb-6 font-serif text-4xl font-bold leading-tight text-[#2D2D2D] sm:text-5xl lg:text-6xl" data-id="element-97">
              The Woman You Were Isn't Gone. She's Just Waiting For You To
              Choose Her Again.
            </h1>
            <p className="mb-8 font-sans text-xl leading-relaxed text-[#2D2D2D]/80" data-id="element-98">
              How to reclaim your body, your energy, and your identity in 90
              days — even if you haven't slept more than 4 hours straight.
            </p>
            <CTAButton text="YES — I'm Ready To Come Back To Me" onClick={() => {
            document.getElementById('cta-final')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-99" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-100">
            <div className="relative aspect-[4/5] overflow-hidden rounded-2xl shadow-2xl" data-id="element-101">
              <img src="https://cdn.magicpatterns.com/uploads/sEBWZC8biHn2vziboGzLxk/BACK_TO_YOU.png" alt="Back To You Digital Postpartum Transformation Program on iPad and iPhone" className="absolute inset-0 h-full w-full object-cover" data-id="element-102" />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-black/10" data-id="element-103" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}